import { createIcon } from '@chakra-ui/react';

export const ChevronRightLastIcon = createIcon({
  displayName: 'ChevronRightLastIcon',
  viewBox: '0 0 32 32',
  path: (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.43934 24.0613C7.85355 24.6192 7.85355 25.5237 8.43934 26.0816C9.02513 26.6395 9.97487 26.6395 10.5607 26.0816L19.5607 17.5102C20.1464 16.9523 20.1464 16.0477 19.5607 15.4898L10.5607 6.91842C9.97487 6.36053 9.02513 6.36053 8.43934 6.91842C7.85355 7.47631 7.85355 8.38083 8.43934 8.93872L16.3787 16.5L8.43934 24.0613ZM22.5 6.5C21.6716 6.5 21 7.17158 21 8L21 25C21 25.8284 21.6716 26.5 22.5 26.5C23.3284 26.5 24 25.8284 24 25L24 8C24 7.17158 23.3284 6.5 22.5 6.5Z'
      fill='currentColor'
    />
  ),
});
